
import cart from './cart'
import actualize from './actualize'
import tourists from './tourists'
import hotels from './hotels'
import flights from './flights'
import transfers from './transfers'
import excursions from './excursions'
import insurances from './insurances'
import cancelInsurances from './cancelInsurances'
import visas from './visas'
import tours from './tours'

const services = [
  cart,
  actualize,
  tourists,
  hotels,
  flights,
  transfers,
  excursions,
  insurances,
  cancelInsurances,
  visas,
  tours
]
const store = {
  state: {},
  getters: {},
  mutations: {},
  actions: {}
}

services.forEach((service) => {
  Object.keys(service).forEach((key) => {
    store[key] = {
      ...store[key],
      ...service[key]
    }
  })
})

export default {
  namespaced: true,
  ...store
}